import {Service} from "vue-typedi";
import {pricesApiClient} from "@/configuration/api-client";
import {Price} from "@/model/Price";

@Service()
export class PriceService {
    public static PRICES_ENDPOINT: string = "/prices";
    private static readonly STORE_ID: string = "storeId";

    public getPrices(payload: string): Promise<Price>  {
        const params = {
            site: sessionStorage.getItem(PriceService.STORE_ID),
            payload,
            format: this.getEANFormat(payload)
        };

        return pricesApiClient.get(PriceService.PRICES_ENDPOINT, { params })
            .then((response: any) => {
                const price: Price = response && response.data ? response.data : [];
                return Promise.resolve(price);

            }).catch((error) => {
                return Promise.reject(error);
            });
    }

    private getEANFormat(EAN: string): string {
        if (EAN.length === 13) {
            return "EAN13";
        }
    }
}
